module.exports = __webpack_public_path__ + "assets/38.jpg?bb8309a5630a80a152cff9806ba2f9b0";